export default "__VITE_ASSET__DN5a_zAH__"